import { useCallback } from 'react';

function useInfiniteScroll({ fetchNext }: { fetchNext: () => unknown }) {
  const infiniteScroll = useCallback(
    (event: React.UIEvent<HTMLElement, UIEvent>) => {
      const { scrollHeight, scrollTop, clientHeight } = event.currentTarget;

      const scrollHeightLeft = scrollHeight - (scrollTop + clientHeight);
      if (scrollHeightLeft > 100) {
        return;
      }

      fetchNext?.();
    },
    [fetchNext]
  );

  return infiniteScroll;
}

export default useInfiniteScroll;
